export const iconFontAwesomeHandsHandSpock = (
	<i className="fa-solid fa-hand-spock"></i>
);
